import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3508">
      <Navbar data-id="element-3509" />
      <main data-id="element-3510">
        <ConsularAffairs data-id="element-3511" />
      </main>
      <Footer data-id="element-3512" />
      <FeedbackPopup data-id="element-3513" />
    </div>;
}